var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M6.128 13.5h11.156c1.004 0 1.505 1.214.797 1.922L12.503 21a1.12 1.12 0 0 1-1.589 0l-5.583-5.578c-.708-.708-.206-1.922.797-1.922m11.953-4.922L12.503 3a1.12 1.12 0 0 0-1.589 0L5.331 8.578c-.708.708-.206 1.922.797 1.922h11.156c1.004 0 1.505-1.214.797-1.922"
  })));
};
export default SvgSort;